var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "			<div class=\"content_provider\">This resource was found in "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.content_provider : stack1), depth0))
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"assoc_res_card\">\n	<a style=\"white-space: normal\" target=\"_blank\" href=\"https://fairsharing.org/"
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\">\n		<span class=\"h6\">"
    + alias2(alias1((depth0 != null ? depth0.label : depth0), depth0))
    + "</span>\n		<i class=\"fa fa-external-link\"></i>\n	</a>\n	<!--\n	<div class=\"more\" data-type=\"database\">\n		more about this database\n	</div>\n	<div class=\"collapsible-description\" id=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\" >\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.content_provider : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		<br>\n		"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.description : stack1), depth0))
    + "\n	</div>\n	-->\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/view_mode/_databases_card.hbs
// module id = 435
// module chunks = 0